import React from 'react';
import {Button} from "@/components/ui/button";
import {MoveRight, X} from "lucide-react";
import {useToggleFilterStore} from "@/store/catalog-filter/toggle-filter-store";

interface IProps {
    selectedFilters: { label: string, value: string }[];
    clearFilters: () => void;
    pageFilterStatus: "brand-filter" | "price-range" | "filter-option"
    setPageFilterStatus: (status: "brand-filter" | "price-range" | "filter-option") => void;
}


/**
 * header for mobile filter component
 * @param selectedFilters
 * @param pageFilterStatus
 * @param setPageFilterStatus
 * @param clearFilters
 * @constructor
 */


function FilterMobileHeaderComponent({
                                         pageFilterStatus,
                                         setPageFilterStatus,
                                         clearFilters
                                     }: IProps) {
    const {setOpen} = useToggleFilterStore();
    return (
        <>

            {
                pageFilterStatus === "filter-option" &&
                <FilterCloseButton clearFilters={clearFilters} setOpen={setOpen}/>
            }

            {
                pageFilterStatus === "brand-filter" &&
                <ReturnFromBrandButton setPageFilterStatus={setPageFilterStatus}/>
            }
            {
                pageFilterStatus === "price-range" &&
                <ReturnFromPriceRangeButton setPageFilterStatus={setPageFilterStatus}/>
            }


        </>
    );
}

export default FilterMobileHeaderComponent;

const FilterCloseButton = ({setOpen, clearFilters}: {
    setOpen: (status: boolean) => void,
    clearFilters: () => void
}) => {
    return (
        <div className="flex w-full py-4 px-[23px] items-center justify-between border-b">
            <div className={"flex items-center"}>
                <Button variant={"none"} className="p-1" onClick={() => setOpen(false)}>
                    <X className="w-5 h-5"/>
                </Button>
                <span className="font-bold ">فیلتر</span>
            </div>
            <div>
                <Button variant={"none"} className={"text-[#FF7745] text-xs p-0"} onClick={clearFilters}>حذف
                    فیلترها
                </Button>
            </div>
        </div>
    )
}


const ReturnFromBrandButton = ({setPageFilterStatus}: {
    setPageFilterStatus: (status: "brand-filter" | "price-range" | "filter-option") => void
}) => {
    return (
        <div className="flex w-full py-4 px-[23px]  items-center justify-between">
            <div className={"flex items-center gap-2"}>
                <Button variant={"ghost"} className="p-1" onClick={() => setPageFilterStatus("filter-option")}>
                    <MoveRight className="w-5 h-5"/>
                </Button>
                <span className="font-bold ">برند ها</span>
            </div>
        </div>
    )
}

const ReturnFromPriceRangeButton = ({setPageFilterStatus}: {
    setPageFilterStatus: (status: "brand-filter" | "price-range" | "filter-option") => void
}) => {
    return (
        <div className="flex w-full py-4 px-[23px]  items-center justify-between">
            <div className={"flex items-center gap-2 "}>
                <Button variant={"ghost"} className="p-1" onClick={() => setPageFilterStatus("filter-option")}>
                    <MoveRight className="w-5 h-5"/>
                </Button>
                <span className="font-bold ">تعیین محدوده قیمت</span>
            </div>
        </div>
    )
}